export const environment = {
  production: true,
  apiBaseUrl: 'https://prod-api.pumpumpum.com',
  domain: 'https://pumpumpum.com',
  sourceType: 'Website',
  source: 'pumpumpum',
};
